import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const CloseButton = styled.TouchableOpacity`
  position: absolute;
  top: ${RFValue(16)}px;
  right:0;
  z-index: 10;
  padding: ${RFValue(4)}px;
`;

export const CloseIcon = styled(Feather)`
  font-size: ${RFValue(22)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const Content = styled.ScrollView.attrs({
  contentContainerStyle: {flexGrow: 1},
  showsVerticalScrollIndicator: false,
})`
  flex: 1;
`;

export const Banner = styled.View`
  background-color: ${({theme}) => theme.colors.success_bg};
  padding: ${RFValue(32)}px ${RFValue(24)}px ${RFValue(48)}px;
  align-items: center;
`;

export const IconWrapper = styled.View`
  background-color: ${({theme}) => theme.colors.price_card};
  width: ${RFValue(64)}px;
  height: ${RFValue(64)}px;
  border-radius: ${RFValue(18)}px;
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(16)}px;
  shadow-color: #000;
  shadow-offset: 0px 4px;
  shadow-opacity: 0.12;
  shadow-radius: 10px;
  elevation: 4;
`;

export const IconCheck = styled(Feather)`
  font-size: ${RFValue(32)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const BannerTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(8)}px;
`;

export const BannerSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.text_dark};
  text-align: center;
  line-height: ${RFValue(20)}px;
  padding: 0 ${RFValue(16)}px;
`;

export const SummaryCard = styled.View`
  background-color: ${({theme}) => theme.colors.price_card};
  border-radius: ${RFValue(16)}px;
  padding: ${RFValue(20)}px;
  margin: -${RFValue(24)}px ${RFValue(24)}px ${RFValue(16)}px;
  shadow-color: #000;
  shadow-offset: 0px 2px;
  shadow-opacity: 0.08;
  shadow-radius: 6px;
  elevation: 3;
`;

export const SummaryRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${RFValue(8)}px;
`;

export const SummaryLabel = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const SummaryValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const Divider = styled.View`
  height: 1px;
  background-color: ${({theme}) => theme.colors.border};
  margin: ${RFValue(4)}px 0 ${RFValue(8)}px;
`;

export const StepsContainer = styled.View`
  padding: ${RFValue(16)}px ${RFValue(24)}px;
`;

export const StepsTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  margin-bottom: ${RFValue(12)}px;
`;

export const StepRow = styled.View`
  flex-direction: row;
  align-items: center;
  margin-bottom: ${RFValue(10)}px;
`;

export const StepIcon = styled(Feather)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.primary};
  margin-right: ${RFValue(12)}px;
`;

export const StepText = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  flex: 1;
`;

export const Footer = styled.View`
  padding: ${RFValue(12)}px ${RFValue(24)}px ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.background};
`;

export const DisclaimerText = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(9)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  margin-bottom: ${RFValue(8)}px;
  line-height: ${RFValue(14)}px;
  padding: 0 24px;
`;

export const ChangeDateLink = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(11)}px;
  color: ${({theme}) => theme.colors.blue};
  margin-left: ${RFValue(8)}px;
`;

export const ModalOverlay = styled.View`
  flex: 1;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
`;

export const ModalCard = styled.View`
  background-color: ${({theme}) => theme.colors.price_card};
  border-radius: ${RFValue(16)}px;
  padding: ${RFValue(24)}px;
  width: 80%;
`;

export const ModalTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(16)}px;
`;

export const DayOptionsRow = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${RFValue(8)}px;
`;

export const DayPill = styled.TouchableOpacity`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(20)}px;
  padding: ${RFValue(10)}px ${RFValue(20)}px;
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
`;

export const DayPillText = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(13)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const SuccessContainer = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 0 ${RFValue(32)}px;
`;

export const SuccessIconWrapper = styled.View`
  background-color: ${({theme}) => theme.colors.success_bg};
  width: ${RFValue(80)}px;
  height: ${RFValue(80)}px;
  border-radius: ${RFValue(40)}px;
  align-items: center;
  justify-content: center;
  margin-bottom: ${RFValue(24)}px;
`;

export const SuccessIconCheck = styled(Feather)`
  font-size: ${RFValue(40)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const SuccessTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(22)}px;
  color: ${({theme}) => theme.colors.title};
  text-align: center;
  margin-bottom: ${RFValue(12)}px;
`;

export const SuccessSubtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
  text-align: center;
  line-height: ${RFValue(22)}px;
`;

export const PhoneModalOverlay = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
  padding: ${RFValue(20)}px;
`;

export const PhoneModalCard = styled.View`
  width: 100%;
  max-width: ${RFValue(340)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(20)}px;
  padding: ${RFValue(24)}px;
  align-items: center;
`;

export const PhoneModalIconWrapper = styled.View`
  width: ${RFValue(56)}px;
  height: ${RFValue(56)}px;
  border-radius: ${RFValue(28)}px;
  background-color: ${({theme}) => theme.colors.primary_light};
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(16)}px;
`;

export const PhoneModalIcon = styled(MaterialCommunityIcons)`
  font-size: ${RFValue(26)}px;
  color: ${({theme}) => theme.colors.primary};
`;

export const PhoneModalTitle = styled.Text`
  text-align: center;
  font-size: ${RFValue(15)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  margin-bottom: ${RFValue(8)}px;
`;

export const PhoneModalBody = styled.Text`
  text-align: center;
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
  line-height: ${RFValue(18)}px;
  margin-bottom: ${RFValue(20)}px;
`;

export const PhoneModalDivider = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  text-align: center;
  align-self: center;
  margin-top: ${RFValue(6)}px;
  margin-bottom: ${RFValue(6)}px;
`;

export const PhoneModalPhoneRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${({theme}) => theme.colors.price_card};
  border-radius: ${RFValue(10)}px;
  padding: ${RFValue(10)}px ${RFValue(16)}px;
  width: 100%;
  padding-left: ${RFValue(38)}px;
`;

export const PhoneModalWhatsIcon = styled(FontAwesome5)`
  font-size: ${RFValue(18)}px;
  color: ${({theme}) => theme.colors.success};
  margin-right: ${RFValue(10)}px;
`;

export const PhoneModalPhoneNumber = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  font-size: ${RFValue(15)}px;
  color: ${({theme}) => theme.colors.title};
  flex: 1;
`;

export const PhoneModalButtonWrapper = styled.View`
  width: 100%;
  margin-top: ${RFValue(16)}px;
`;
